module.exports = __webpack_public_path__ + "static/container_intro.b0c53f3b.png";